export default {"src":"/_next/static/media/x.d96e56ee.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};